module.exports = __webpack_public_path__ + "static/img/student_boy.a8145b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/student_boy.png
// module id = wmSf
// module chunks = 79